import articlesModule from "./articlesModule";
import settingsModule from "./settingsModule";
import tagsModule from "./tagsModule";
import statsModule from "./statsModule";
import reportersModule from "./reportersModule";
export default {
  articlesModule,
  settingsModule,
  tagsModule,
  statsModule,
  reportersModule
};
